import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

var _updateItem$addStuden;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import constants from "../../constants";
import http from "../http";
var CLASSES_ENDPOINT = "".concat(constants.API_URL, "/classes");

function classUrl(id) {
  return "".concat(CLASSES_ENDPOINT, "/").concat(id);
}

function moveBulkStudents(_x) {
  return _moveBulkStudents.apply(this, arguments);
}

function _moveBulkStudents() {
  _moveBulkStudents = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref) {
    var sourceClassId, destinationClassId, studentIds, response;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            sourceClassId = _ref.sourceClassId, destinationClassId = _ref.destinationClassId, studentIds = _ref.studentIds;
            _context6.next = 3;
            return http.post("".concat(CLASSES_ENDPOINT, "/").concat(sourceClassId, "/students/move-bulk"), {
              destinationClassId: destinationClassId,
              studentIds: studentIds
            });

          case 3:
            response = _context6.sent;
            return _context6.abrupt("return", response);

          case 5:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _moveBulkStudents.apply(this, arguments);
}

function getClassCertificates(_x2) {
  return _getClassCertificates.apply(this, arguments);
}

function _getClassCertificates() {
  _getClassCertificates = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref2) {
    var semesterId, classId, interval, _yield$http$get, data;

    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            semesterId = _ref2.semesterId, classId = _ref2.classId, interval = _ref2.interval;
            _context7.next = 3;
            return http.get("".concat(constants.API_URL, "/classes/").concat(classId, "/certificates"), {
              params: _objectSpread({
                semesterId: semesterId
              }, interval)
            });

          case 3:
            _yield$http$get = _context7.sent;
            data = _yield$http$get.data;
            return _context7.abrupt("return", data);

          case 6:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _getClassCertificates.apply(this, arguments);
}

function getClassCertificatesCustomGrading(_x3) {
  return _getClassCertificatesCustomGrading.apply(this, arguments);
}

function _getClassCertificatesCustomGrading() {
  _getClassCertificatesCustomGrading = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref3) {
    var classId, gradebookSystemId, interval, semesterId, _yield$http$get2, data;

    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            classId = _ref3.classId, gradebookSystemId = _ref3.gradebookSystemId, interval = _ref3.interval, semesterId = _ref3.semesterId;
            _context8.next = 3;
            return http.get("".concat(constants.API_URL, "/classes/").concat(classId, "/gradebook-systems/").concat(gradebookSystemId, "/certificates"), {
              params: _objectSpread({
                semesterId: semesterId
              }, interval)
            });

          case 3:
            _yield$http$get2 = _context8.sent;
            data = _yield$http$get2.data;
            return _context8.abrupt("return", data);

          case 6:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _getClassCertificatesCustomGrading.apply(this, arguments);
}

function updateItem(_x4) {
  return _updateItem.apply(this, arguments);
}

function _updateItem() {
  _updateItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref4) {
    var classId, data, response;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            classId = _ref4.classId, data = _ref4.data;
            _context9.next = 3;
            return http.patch("".concat(classUrl(classId)), data);

          case 3:
            response = _context9.sent;
            return _context9.abrupt("return", response);

          case 5:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _updateItem.apply(this, arguments);
}

function addStudent(_x5) {
  return _addStudent.apply(this, arguments);
}

function _addStudent() {
  _addStudent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(_ref5) {
    var classId, studentId, response;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            classId = _ref5.classId, studentId = _ref5.studentId;
            _context10.next = 3;
            return http.post("".concat(classUrl(classId), "/students"), {
              studentId: studentId
            });

          case 3:
            response = _context10.sent;
            return _context10.abrupt("return", response);

          case 5:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _addStudent.apply(this, arguments);
}

var deleteBulkClasses = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref6) {
    var data, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            data = _ref6.data;
            _context.next = 3;
            return http.post("".concat(constants.API_URL, "/classes/delete-bulk"), data);

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function deleteBulkClasses(_x6) {
    return _ref7.apply(this, arguments);
  };
}();

var getClassCertificateDefaults = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref8) {
    var classId, params, response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            classId = _ref8.classId, params = _ref8.params;
            _context2.next = 3;
            return http.get("".concat(CLASSES_ENDPOINT, "/").concat(classId, "/certificate-defaults"), {
              params: params
            });

          case 3:
            response = _context2.sent;
            return _context2.abrupt("return", response);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getClassCertificateDefaults(_x7) {
    return _ref9.apply(this, arguments);
  };
}();

var upsertCertificateDefaults = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref10) {
    var classId, certificateTemplateId, data, response;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            classId = _ref10.classId, certificateTemplateId = _ref10.certificateTemplateId, data = _ref10.data;
            _context3.next = 3;
            return http.post("".concat(CLASSES_ENDPOINT, "/").concat(classId, "/certificate-templates/").concat(certificateTemplateId, "/upsert-certificate-defaults"), data);

          case 3:
            response = _context3.sent;
            return _context3.abrupt("return", response);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function upsertCertificateDefaults(_x8) {
    return _ref11.apply(this, arguments);
  };
}();

var issueCertificate = /*#__PURE__*/function () {
  var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref12) {
    var data, response;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            data = _ref12.data;
            _context4.next = 3;
            return http.post("".concat(CLASSES_ENDPOINT, "/issue-certificates"), data);

          case 3:
            response = _context4.sent;
            return _context4.abrupt("return", response);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function issueCertificate(_x9) {
    return _ref13.apply(this, arguments);
  };
}();

var getClassDismissals = /*#__PURE__*/function () {
  var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref14) {
    var classId, params, response;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            classId = _ref14.classId, params = _ref14.params;
            _context5.next = 3;
            return http.get("".concat(CLASSES_ENDPOINT, "/").concat(classId, "/dismissals"), {
              params: params
            });

          case 3:
            response = _context5.sent;
            return _context5.abrupt("return", response);

          case 5:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function getClassDismissals(_x10) {
    return _ref15.apply(this, arguments);
  };
}();

export default (_updateItem$addStuden = {
  updateItem: updateItem,
  addStudent: addStudent,
  getClassCertificates: getClassCertificates,
  moveBulkStudents: moveBulkStudents
}, _defineProperty(_updateItem$addStuden, "getClassCertificates", getClassCertificates), _defineProperty(_updateItem$addStuden, "getClassCertificatesCustomGrading", getClassCertificatesCustomGrading), _defineProperty(_updateItem$addStuden, "deleteBulkClasses", deleteBulkClasses), _defineProperty(_updateItem$addStuden, "getClassCertificateDefaults", getClassCertificateDefaults), _defineProperty(_updateItem$addStuden, "upsertCertificateDefaults", upsertCertificateDefaults), _defineProperty(_updateItem$addStuden, "issueCertificate", issueCertificate), _defineProperty(_updateItem$addStuden, "getClassDismissals", getClassDismissals), _updateItem$addStuden);